<template>
    <div class="tv">
        <!-- buttons row -->
        <el-row>
            <el-col :span="24" style="display: flex; -webkit-flex-direction: row-reverse; flex-direction: row-reverse; align-items: center;">
                <el-button type="text" @click="toggleFullscreen">{{isFullscreen ? 'Exit Full Screen' : 'Full Screen'}}</el-button>
                <el-button type="text" @click="goto('/carry-freight/schedule-monitor/')" style="margin-right:20px;"><i class="el-icon-back"/>Exit Tv Mode</el-button>
                <el-select style="width: 120px; margin-right:20px;" v-model="value" @change="updateDayRange">
                    <el-option
                            v-for="item in dayRanges"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                    </el-option>
                </el-select>
                <span style="color: #409eff; font-size: 12px; margin-right:20px;">* To change the destinations shown, go to "My Settings" and change the branches selected</span>
                <el-button v-if="false" type="primary" icon="el-icon-refresh-left" @click="loadJourneys">Reload</el-button>
                <el-button v-if="false" type="success">
                    Last update time: {{journeysUpdateTime.format("h:mm a")}} ({{journeysUpdateTimeHuman}})
                </el-button>
            </el-col>
        </el-row>
        <!-- table row -->
        <el-row>
            <el-col v-loading="isLoadingJourneys" :span="24" style="text-align: center">
                <el-table
                        style="width: 100%"
                        :data="truckRunningJourneys.slice((currpage - 1) * pagesize, currpage * pagesize)"
                        :cell-class-name="cellClassName"
                        :show-overflow-tooltip="true"
                        border
                        empty-text="No scheduled trip is being monitored now"
                        :row-style="{height:'40px'}"
                        class="table-tv"
                        :max-height="1900"
                >
                    <el-table-column
                            prop="originPlace"
                            label="Origin"
                            min-width="10%"
                            :show-overflow-tooltip="true"
                    >
                        <template slot-scope="scope">
                            {{scope.row.originPlace.name}}
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="destinationPlace"
                            label="Destination"
                            min-width="10%"
                            :show-overflow-tooltip="true"
                    >
                        <template slot-scope="scope">
                            {{scope.row.destinationPlace.name}}
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="truckPlate"
                            label="Truck"
                            min-width="13%"
                    ></el-table-column>
                    <el-table-column
                            label="Departure"
                            min-width="13%"
                    >
                        <template slot-scope="scope">
                            <div>
                                {{getCalendarDate(scope.row.std)}}
                            </div>
                            <div style="float: left;">
                                {{getTime(scope.row.std)}}
                            </div>
                            <div style="float: left;padding: 0 0 0 2px;" :class="[scope.row.atdClass]">
                                {{getTime(scope.row.atd)}}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                            label="Arrival"
                            min-width="13%"
                    >
                        <template slot-scope="scope">
                            <div>
                                {{getCalendarDate(scope.row.sta)}}
                            </div>
                            <div style="float: left;">
                                {{getTime(scope.row.sta)}}
                            </div>
                            <div style="float: left;padding: 0 0 0 2px;" :class="[scope.row.etaOrAtaClass]">
                                {{getTime(scope.row.etaOrAta)}}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                            label="Status"
                            property="status"
                            min-width="18%"
                    >
                        <template slot-scope="scope">
                            {{scope.row.status}}
                        </template>
                    </el-table-column>
                    <el-table-column
                            label="Location"
                            align="center"
                            min-width="23%"
                    >
                        <template slot-scope="scope">
                            <div v-if="scope.row.status.toLowerCase().includes('expected to') && scope.row.latestPoint">
                                <div>
                                    {{scope.row.latestPoint.location.split(',')[0]}} {{`(${scope.row.latestPoint.speed} km/h)`}} {{scope.row.latestPoint.time.format("h:mma")}}
                                </div>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </el-col>
        </el-row>
        <el-row v-if="false">
            <el-col :span="16" style="text-align: center">
                <el-pagination
                        background
                        layout="prev, pager, next, sizes, total, jumper"
                        :page-sizes="[1, 5, 10, 15, 20]"
                        :page-size="pagesize"
                        :total="truckRunningJourneys.length"
                        @current-change="handleCurrentChange"
                        @size-change="handleSizeChange"
                        :current-page="currpage"
                >
                </el-pagination>
            </el-col>
        </el-row>
    </div>
</template>

<script>
    export default {
        // Do not forget this little guy
        name: 'SchedulesMonitorTv',
        // share common functionality with component mixins
        mixins: [],
        // compose new components
        extends: {},
        // component properties/variables
        props: {
        },
        // variables
        data() {
            return {
                value: null,
                isFullscreen: false,
                dayRanges: [
                    {
                        value: 0,
                        label: 'Default'
                    },
                    {
                        value: 50,
                        label: 'Forklift'
                    },
                ],
                momentNow: moment(),
                journeysUpdateTime: moment(),
                //pagination
                pagesize: 5,
                currpage: 1,
                stayTime: 10, //unit: second
                minimumReloadInterval: 5, //uni: minute
                looped: false,
            }
        },
        computed: {
            journeysUpdateTimeHuman: function () {
                return this.journeysUpdateTime.from(this.momentNow);
            },
            truckRunningJourneys () {
                return this.$store.getters.getTruckRunningJourneys;
            },
            isLoadingJourneys () {
                return this.$store.getters.getTruckRunningJourneysLoadStatus === 1;
            },
            isLoadingSetting () {
                return this.$store.getters.getTruckRunningSettingLoadStatus === 1;
            },
            dayRange () {
                return this.$store.getters.getDayRange;
            },
        },
        // when component uses other components
        components: {},
        // methods
        methods: {
            goto(url) {
                location.href = url;
            },
            toggleFullscreen (event) {
                const elem = document.documentElement;
                if (
                    document.fullscreenEnabled ||
                    document.webkitFullscreenEnabled ||
                    document.mozFullScreenEnabled ||
                    document.msFullscreenEnabled
                ) {
                    if (!this.isFullscreen) {
                        if (elem.requestFullscreen) {
                            elem.requestFullscreen();
                            this.isFullscreen = true;
                            return;
                        } else if (elem.webkitRequestFullscreen) {
                            elem.webkitRequestFullscreen();
                            this.isFullscreen = true;
                            return;
                        } else if (elem.mozRequestFullScreen) {
                            elem.mozRequestFullScreen();
                            this.isFullscreen = true;
                            return;
                        } else if (elem.msRequestFullscreen) {
                            elem.msRequestFullscreen();
                            this.isFullscreen = true;
                            return;
                        }
                    } else {
                        if (document.exitFullscreen) {
                            document.exitFullscreen();
                            this.isFullscreen = false;
                            return;
                        } else if (document.webkitExitFullscreen) {
                            document.webkitExitFullscreen();
                            this.isFullscreen = false;
                            return;
                        } else if (document.mozCancelFullScreen) {
                            document.mozCancelFullScreen();
                            this.isFullscreen = false;
                            return;
                        } else if (document.msExitFullscreen) {
                            document.msExitFullscreen();
                            this.isFullscreen = false;
                            return;
                        }
                    }
                }
            },
            cellClassName({row, column, rowIndex, columnIndex}) {
                if (column.property === 'status') {
                    return row.statusClasses.join(' ');
                }
            },
            updateDayRange (value) {
/*                this.$store.dispatch('updateDayRange', value);
                this.loadJourneys();*/
            },
            loadJourneys () {
                console.log('dispatch load journeys');
                const loadingJourneysMessage = this.$message({
                    message: 'Loading Journeys...',
                    center: true
                });
                this.$store.dispatch('loadTruckRunningJourneys', { mode: 'tv'})
                    .then(() => this.journeysUpdateTime = moment())
                    .catch(() => this.$message.error('Sorry, failed to load the journeys.'))
                    .then(() => {
                        loadingJourneysMessage.close();
                        this.looped = false;
                        this.currpage = 1;
                    });
            },
            getCalendarDate (time) {
                return time ? time.calendar(null, {
                    sameDay: '[]',
                    nextDay: '[Tomorrow]',
                    nextWeek: function callback (now) {
                        return now.isoWeek() === time.isoWeek() ? 'dddd' : '[Next] dddd';
                    },
                    lastDay: '[Yesterday]',
                    lastWeek: function callback (now) {
                        return now.isoWeek() === time.isoWeek() ? 'dddd' : '[Last] dddd';
                    },
                    sameElse: 'Do MMM'
                }) : null;
            },
            getTime (moment = null) {
                if (moment !== null) {
                    return moment.format("h:mma");
                }
                return null;
            },
            //pagination
            handleCurrentChange(cpage) {
                this.currpage = cpage;
            },
            handleSizeChange(psize) {
                this.pagesize = psize;
            },
            goNextPage() {
                console.log('goNextPage');
                if (this.truckRunningJourneys.length <= this.currpage * this.pagesize) {
                    this.currpage = 1;
                    if (moment().diff(this.journeysUpdateTime, 'seconds') >= 60 * this.minimumReloadInterval) {
                        this.loadJourneys();
                    }
                } else {
                    this.currpage++;
                }
            }
        },
        // component Lifecycle hooks
        beforeDestroy() {
            clearInterval(this.interval);
            clearInterval(this.reloadInterval);
        },
        created() {
            this.loadJourneys();
            this.reloadInterval = setInterval(() => this.goNextPage(), this.stayTime * 1000);//go to next page every 30 seconds
            this.interval = setInterval(() => this.momentNow = moment(), 10000); //update moment now every 10 seconds
        },
    };
</script>

<style scoped>
    >>> .text-eta {
        text-decoration: underline;
    }

    >>> .text-on-time {
        color: unset;
    }

    >>> .text-delay-yellow {
        color: #e6a23c;
    }

    >>> .text-delay-red {
        color: #f56c6c;
    }

    >>> .status-cell.on-time {
        background: #67C23A;
    }

    >>> .el-table--enable-row-hover .el-table__body tr:hover>.status-cell.on-time {
        background: #67C23A;
    }

    >>> .status-cell.delay-yellow {
        background: #E6A23C;
    }

    >>> .el-table--enable-row-hover .el-table__body tr:hover>.status-cell.delay-yellow {
        background: #E6A23C;
    }

    >>> .status-cell.delay-red {
        background: #F56C6C;
    }

    >>> .el-table--enable-row-hover .el-table__body tr:hover>.status-cell.delay-red {
        background: #F56C6C;
    }

    >>> svg {
        vertical-align: unset;
    }

    label {
        margin-bottom: 0;
    }

    >>> .el-table .cell {
        word-break: normal;
    }

    >>> .table-tv td {
        font-family: Sans-serif,serif;
        font-size: 48px;
        font-weight: bold;
        color: black;
    }

    >>> .table-tv td .cell {
        line-height: 48px;
    }

    >>> .table-tv th {
        font-size: 36px;
    }

    >>>.table-tv th .cell {
        line-height: 36px;
    }

    .tv {
        padding: 10px 30px;
        position: fixed;
        left: 0;
        top: 0;
        bottom: 0;
        width: 100%;
        height: 100vh;
        overflow: hidden;
        background-color: white;
        z-index: 1;
    }
</style>